import { Component, Input, OnChanges } from "@angular/core";

export interface HBarRow {
  label: string;
  value: number;
  display?: string;
}

@Component({
  selector: "app-hbar-list",
  standalone: true,
  imports: [],
  template: `
    <div class="hbar-list" [class.no-label]="!showLabel">
      @for (r of rendered; track r.label) {
        <div class="hbar-row">
          @if (showLabel) {
            <div class="hbar-label" [title]="r.label">{{ r.label }}</div>
          }
          <div class="hbar-track">
            <div
              class="hbar-fill"
              [class.pos]="colorMode === 'pos'"
              [class.neg]="
                colorMode === 'neg' || (colorMode === 'auto' && r.value < 0)
              "
              [style.width.%]="r.widthPct"
            ></div>
          </div>
          <div class="hbar-val">{{ r.display ?? format(r.value) }}</div>
        </div>
      }
    </div>
  `,
})
export class HbarListComponent implements OnChanges {
  @Input() rows: HBarRow[] = [];
  @Input() colorMode: "accent" | "pos" | "neg" | "auto" = "accent";
  @Input() format: (v: number) => string = (v) => (v * 100).toFixed(1) + "%";
  @Input() maxOverride?: number;
  @Input() showLabel = true;

  rendered: Array<HBarRow & { widthPct: number }> = [];

  ngOnChanges(): void {
    const max =
      this.maxOverride ??
      Math.max(...this.rows.map((r) => Math.abs(r.value)), 0.0001);
    this.rendered = this.rows.map((r) => ({
      ...r,
      widthPct: Math.min(100, (Math.abs(r.value) / max) * 100),
    }));
  }
}
